import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';
import * as projectApi from '../../lib/api/project';
import { recentOneYearStr, recentOneYearEndStr } from '../../utils/calcDatetime';

/**
 * 매입(보낸)발주서:(B)=> 발주서 보기
 */

const [
  LIST_BUYS_ORDER_SHEET,
  LIST_BUYS_ORDER_SHEET_SUCCESS,
  LIST_BUYS_ORDER_SHEET_FAILURE,
] = createRequestActionTypes('project/LIST_BUYS_ORDER_SHEET');

export const listBuysOrderSheet = createAction(
  LIST_BUYS_ORDER_SHEET,
  (searchData) => ({ salesType: 'B', searchData }),
);
const listBuysOrderSheetSaga = createRequestSaga(
  LIST_BUYS_ORDER_SHEET,
  projectApi.getOrderSheetFiles,
);

const UNLOAD_BUYS_ORDER_SHEET = 'project/UNLOAD_BUYS_ORDER_SHEET';
export const unloadBuysOrderSheet = createAction(UNLOAD_BUYS_ORDER_SHEET);

const SET_BUYS_ORDER_SHEET_FITERS = 'project/SET_BUYS_ORDER_SHEET_FITERS';
export const setBuysOrderSheetFilters = createAction(
  SET_BUYS_ORDER_SHEET_FITERS,
  (filters) => filters,
);

const RESET_BUYS_ORDER_SHEET_FILTERS = 'project/RESET_BUYS_ORDER_SHEET_FILTERS';
export const resetBuysOrderSheetFilters = createAction(
  RESET_BUYS_ORDER_SHEET_FILTERS,
);

export function* buysOrderSheetSaga() {
  yield takeLatest(LIST_BUYS_ORDER_SHEET, listBuysOrderSheetSaga);
}

const initialState = {
  ordersheets: null,
  error: null,
  defaultFilters: {
    searchKeyword: 'cstNm',
    searchWords: '',
    // 비워두지 않고 오늘 기준 앞뒤 1년을 기본 조회범위로 둔다.
    searchStrtDt: recentOneYearStr,
    searchEndDt: recentOneYearEndStr,
  },
};

const buysOrderSheet = handleActions(
  {
    [LIST_BUYS_ORDER_SHEET_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      ordersheets: data.list.map((ordersheet) => ({
        id: ordersheet.spoUuid,
        spoUuid: ordersheet.spoUuid,
        prjUuid: ordersheet.prjUuid,
        cstNm: ordersheet.cstNm,
        orderSheetNo: ordersheet.orderSheetNo,
        sellPartnerUuid: ordersheet.sellPartnerUuid,
        sellPartnerNm: ordersheet.sellPartnerNm,
        sheetCrtDate: ordersheet.sheetCrtDate,
        sheetUsrNm: ordersheet.sheetUsrNm,
        sheetUsrTel: ordersheet.sheetUsrTel,
        sheetCstNm: ordersheet.sheetCstNm,
        sheetPayCond: ordersheet.sheetPayCond,
        sheetPeriod: ordersheet.sheetPeriod,
        sheetDesc: ordersheet.sheetDesc,
        sheetTotal: ordersheet.sheetTotal,
        useYn: ordersheet.useYn,
        crtUsr: ordersheet.crtUsr,
        crtNm: ordersheet.crtNm,
        crtDt: ordersheet.crtDt,
        cngUsr: ordersheet.cngUsr,
        cngNm: ordersheet.cngNm,
        cngDt: ordersheet.cngDt,
      })),
      error: null,
    }),
    [LIST_BUYS_ORDER_SHEET_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_BUYS_ORDER_SHEET]: () => initialState,
    [RESET_BUYS_ORDER_SHEET_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_BUYS_ORDER_SHEET_FITERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default buysOrderSheet;
